// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".d-front-page-custom .c-hero-item{padding-top:100px}.c-hero-item>a{transform:translateX(-50%)}.c-hero-item>h1{font-weight:700;line-height:.75}.c-hero-item iframe{height:100%;left:0;position:absolute;top:0;width:100%}.c-hero-item>span{font-family:Caveat Brush,cursive}@media (min-width:48em){.d-front-page-custom .c-hero-item{padding-top:30px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
